import { motion } from "framer-motion";
import { IMAGES } from "@/lib/constants";
import { useI18n } from "@/i18n/I18nContext";

export const Marraine = () => {
  const { t } = useI18n();
  return (
    <section id="marraine" data-testid="marraine-section" className="relative py-28 md:py-36 px-6 lg:px-10 bg-theatre-surface/40">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="relative"
        >
          <div className="absolute -inset-4 spotlight-glow" aria-hidden="true" />
          <img
            src={IMAGES.marianneBust}
            alt="Laetitia Casta et le buste de Marianne sculpté par Marie-Paule Deville-Chabrolle"
            data-testid="marraine-image"
            className="relative w-full object-cover border border-theatre-gold/20 grayscale"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
        >
          <p className="font-mono text-xs tracking-[0.3em] uppercase text-theatre-gold mb-5">{t("marraine.eyebrow")}</p>
          <h2 className="font-serif text-3xl md:text-5xl text-white leading-tight">
            {t("marraine.titleLine1")}<br /><span className="italic text-theatre-gold">{t("marraine.titleLine2")}</span>
          </h2>
          <div className="mt-6 h-px w-32 gold-hr" />
          <p className="mt-8 text-neutral-300 text-lg leading-relaxed">{t("marraine.p1")}</p>
          <p className="mt-6 text-neutral-400 leading-relaxed">{t("marraine.p2")}</p>
          <p className="mt-8 font-serif italic text-theatre-gold text-xl">{t("marraine.quote")}</p>
        </motion.div>
      </div>
    </section>
  );
};
